import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { Container, Column, Row } from "../grid";
import { css, StyleSheet } from "aphrodite";
import Header from "./Header";
import FooterRow from "./FooterRow";
import { NotificationContainer } from "react-notifications";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	contentContainer: {
		backgroundColor: colors.white,
		paddingTop: 45,
		paddingLeft: 83,
		paddingRight: 77,
		paddingBottom: 46,
		marginBottom: 140, // margin bottom values are based on the height of the footer
		flexDirection: "column",
		display: "flex",
		marginTop: 80,
		[breakpoints.mobileOnly]: {
			paddingLeft: 20,
			paddingRight: 20,
			marginTop: 60,
			marginBottom: 240,
		},
	},
	pageContainer: {
		minHeight: "100vh",
		position: "relative",
		backgroundColor: colors.teal2,
	},
	title: {
		textAlign: "center",
		fontSize: 60,
		lineHeight: 0.92,
		fontWeight: 300,
		color: colors.black,
		fontFamily: "PopulaireLight",
		letterSpacing: 3,
		marginTop: 0,
		marginBottom: 0,
		"@media print": {
			display: "none",
		},
	},
});

export default class LoggedOutPage extends PureComponent {
	static propTypes = {
		children: PropTypes.object.isRequired,
		currentRoute: PropTypes.string.isRequired,
		language: PropTypes.string.isRequired,
		pageTitle: PropTypes.string,
	};

	render() {
		return (
			<div className={css(styles.pageContainer)}>
				<a className="skip-main" href="#main">
					Skip to main content
				</a>
				<Header
					currentRoute={this.props.currentRoute}
					language={this.props.language}
					loggedIn={false}
					profileClicked={this._profileClicked}
					logoutClicked={this._logout}
					inApp={false}
				/>
				<NotificationContainer />
				<Container>
					<Row>
						<Column
							large={8}
							largeOffset={2}
							medium={10}
							mediumOffset={1}
							smallFullScreen={true}
						>
							<div id="main" className={css(styles.contentContainer)}>
								<h1 className={css(styles.title)}>{this.props.pageTitle}</h1>
								{this.props.children}
							</div>
						</Column>
					</Row>
				</Container>
				<FooterRow language={this.props.language} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LoggedOutPage.js